import { render, staticRenderFns } from "./Versoes.vue?vue&type=template&id=d3a230c8&"
import script from "./Versoes.vue?vue&type=script&lang=js&"
export * from "./Versoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports